/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner } from './get-monthly-card-transactions-for-the-user200-response-merged-transaction-detail-list-inner-merged-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
 */
export interface GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionType': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionRecordList': Array<GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'isCleared': boolean;
}

export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum];


